interface ModalProps {
  onClick?: any
  tall?: boolean
  children: React.ReactNode
}

const ModalStripe: React.FunctionComponent<ModalProps> = ({
  onClick,
  tall,
  children
}) => {
  return (
    <div className='bg-black flex justify-center items-center'>
      <div className='glow-effect'>
        <div className='diamond-corner p-[4px] bg-dopage-lightGreen min-h-[400px] min-w-[670px] w-full'>
          {/* Remove the fixed height and let it grow naturally */}
          <div className={`inner bg-black ${tall === true ? 'min-h-[750px]' : 'min-h-[580px]'}`} data-testid='modal-stripe-inner'>
            <div className='p-[22px] flex flex-col items-center text-dopage-lightGreen h-full'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalStripe
